// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useReactOidc } from '@axa-fr/react-oidc-context'

import { getCustomerAccount } from '../../utils/feature-flag-utils'

const LoginRoute = () => {
  const { login, oidcUser } = useReactOidc()
  const navigate = useNavigate()

  useEffect(() => {
    const account = getCustomerAccount()
    if (oidcUser && account) {
      navigate('/home')
    } else if (oidcUser) {
      navigate(`/post-onboarding/choose-account`)
    } else {
      login()
    }
  }, [oidcUser, login]) // eslint-disable-line react-hooks/exhaustive-deps

  return null
}

export default LoginRoute
